import React from 'react';
import { render, screen, fireEvent } from '@testing-library/react';

import Versions from 'components/layouts/ManagementLayout/Versions';

const PROPS = {
  copyright: 'Copyright © 2026 Decisiv, Inc.',
  links: [
    {
      label: 'Data Governance',
      url: 'https://www.decisiv.com/data-governance-statement',
    },
    { label: 'Privacy Policy', url: 'https://www.decisiv.com/privacy-policy' },
    { label: 'Terms of Use', url: 'https://www.decisiv.com/terms-of-use' },
    { label: 'Cookie Policy', url: 'https://www.decisiv.com/cookie-policy' },
  ],
  logoAlt: 'Decisiv Logo',
  logoSrc: '/assets/powered_by_decisiv-abc123.png',
  version: 'Version 1.2.3',
};

const renderVersions = (props = {}) =>
  render(<Versions {...PROPS} {...props} />);

describe('Versions', () => {
  it('renders the powered-by logo linking to decisiv.com', () => {
    renderVersions();

    const logo = screen.getByAltText('Decisiv Logo');
    expect(logo).toHaveAttribute('src', PROPS.logoSrc);
    expect(logo.closest('a')).toHaveAttribute(
      'href',
      'https://www.decisiv.com/',
    );
  });

  it('omits the logo when none is supplied', () => {
    // display_decisiv_logo? is false for some tenants, so the controller omits it.
    renderVersions({ logoSrc: undefined });

    expect(screen.queryByAltText('Decisiv Logo')).not.toBeInTheDocument();
  });

  it('renders the copyright and version', () => {
    renderVersions();

    expect(
      screen.getByText('Copyright © 2026 Decisiv, Inc.'),
    ).toBeInTheDocument();
    expect(screen.getByText('Version 1.2.3')).toBeInTheDocument();
  });

  it('omits the version line when unknown', () => {
    renderVersions({ version: undefined });

    expect(screen.queryByText(/^Version/)).not.toBeInTheDocument();
  });

  it('renders each legal link, opening in a new tab', () => {
    renderVersions();

    PROPS.links.forEach(({ label, url }) => {
      const link = screen.getByRole('link', { name: label });
      expect(link).toHaveAttribute('href', url);
      expect(link).toHaveAttribute('target', '_blank');
      expect(link).toHaveAttribute('rel', 'noopener noreferrer');
    });
  });

  describe('cookie preferences', () => {
    it('is omitted when no label is supplied', () => {
      // The controller only supplies it in production, where Osano is loaded.
      renderVersions();

      expect(
        screen.queryByRole('button', { name: 'Cookie Preferences' }),
      ).not.toBeInTheDocument();
    });

    it('opens the Osano drawer when clicked', () => {
      const showDrawer = jest.fn();
      window.Osano = { cm: { showDrawer } };

      renderVersions({ cookiePreferencesLabel: 'Cookie Preferences' });
      fireEvent.click(
        screen.getByRole('button', { name: 'Cookie Preferences' }),
      );

      expect(showDrawer).toHaveBeenCalledWith('osano-cm-dom-info-dialog-open');

      delete window.Osano;
    });

    it('does not blow up when Osano failed to load', () => {
      renderVersions({ cookiePreferencesLabel: 'Cookie Preferences' });

      expect(() =>
        fireEvent.click(
          screen.getByRole('button', { name: 'Cookie Preferences' }),
        ),
      ).not.toThrow();
    });
  });
});
